"use strict";
/**
 * imports
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTickReRender = void 0;
// external
const react_1 = require("react");
// local
const TickContext_1 = require("../contexts/TickContext");
/**
 * use context to for re-render on tick update
 *
 * @returns {unixTimestamp}
 */
function useTickReRender() {
    const { tick } = (0, react_1.useContext)(TickContext_1.TickContext);
    return tick;
}
exports.useTickReRender = useTickReRender;
//# sourceMappingURL=useTickReRender.js.map